import { __extends } from "tslib";
import { canUseDOM } from 'fbjs/lib/ExecutionEnvironment';
import { element, func, oneOfType } from 'prop-types';
import React, { Component } from 'react';
/**
 * Touch devices emulate mouse events. This functions makes it possible to know
 * if the current modality supports hover (including for multi-modality
 * devices).
 */
var createHoverMonitor = function () {
  var isHoverEnabled = false;
  var lastTouchTime = 0;
  function enableHover() {
    if (isHoverEnabled || Date.now() - lastTouchTime < 500) {
      return;
    }
    isHoverEnabled = true;
  }
  function disableHover() {
    lastTouchTime = new Date();
    if (isHoverEnabled) {
      isHoverEnabled = false;
    }
  }
  if (canUseDOM) {
    var document_1 = typeof window != undefined ? window.document : {};
    document_1.addEventListener('touchstart', disableHover, true);
    document_1.addEventListener('mousemove', enableHover, true);
  }
  return {
    get isEnabled() {
      return isHoverEnabled;
    }
  };
};
var hover = createHoverMonitor();
var Hoverable = /** @class */function (_super) {
  __extends(Hoverable, _super);
  function Hoverable() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      isHovered: false
    };
    _this._handleMouseEnter = function (e) {
      if (hover.isEnabled && !_this.state.isHovered) {
        var onHoverIn = _this.props.onHoverIn;
        if (onHoverIn) {
          onHoverIn();
        }
        _this.setState(function () {
          return {
            isHovered: true
          };
        });
      }
    };
    _this._handleMouseLeave = function (e) {
      if (_this.state.isHovered) {
        var onHoverOut = _this.props.onHoverOut;
        if (onHoverOut) {
          onHoverOut();
        }
        _this.setState(function () {
          return {
            isHovered: false
          };
        });
      }
    };
    return _this;
  }
  Hoverable.prototype.render = function () {
    var _a = this.props,
      children = _a.children,
      /* eslint-disable */
      onHoverIn = _a.onHoverIn,
      onHoverOut = _a.onHoverOut
      /* eslint-enable */;
    var child = typeof children === 'function' ? children(this.state.isHovered) : children;
    return /*#__PURE__*/React.cloneElement(React.Children.only(child), {
      onMouseEnter: this._handleMouseEnter,
      onMouseLeave: this._handleMouseLeave
    });
  };
  return Hoverable;
}(Component);
Hoverable.propTypes = {
  children: oneOfType([func, element]).isRequired,
  onHoverIn: func,
  onHoverOut: func
};
export default Hoverable;